import { formatMoney } from '@shopify/theme-currency';

const selectors = {
    wrapper: '[data-added-to-cart-modal-wrapper]',
    modal: '[data-added-to-cart-modal]',
    details: '[data-product-details]',
    image: '[data-details-image]',
    title: '[data-details-title]',
    type: '[data-details-type]',
    message: '[data-details-message]',
    price: '[data-details-price]',
    options: '[data-details-options]',
    quantityCount: '[data-details-quantity] [data-quantity-count]',
};

const $addedToCartModalWrapper = document.querySelector(selectors.wrapper);
const $addedToCartModal = document.querySelector(selectors.modal);
const $title = document.querySelector(selectors.title);
const $image = document.querySelector(selectors.image);
const $message = document.querySelector(selectors.message);
const $price = document.querySelector(selectors.price);
const $options = document.querySelector(selectors.options);
const $quantityCount = document.querySelector(selectors.quantityCount);

function show() {
    $addedToCartModal.setAttribute('data-modal-state', 'open');
    $addedToCartModal.setAttribute('aria-hidden', 'false');
    $addedToCartModalWrapper.setAttribute('data-blur', 'true');
    $addedToCartModalWrapper.setAttribute('data-state', 'visible');
    document.body.style.overflowY = 'hidden';
}
function hide() {
    $addedToCartModal.setAttribute('data-modal-state', 'closed');
    $addedToCartModal.setAttribute('aria-hidden', 'true');
    $addedToCartModalWrapper.setAttribute('data-blur', 'false');
    $addedToCartModalWrapper.setAttribute('data-state', 'hidden');
    document.body.style.overflowY = '';
}

function resetPreviousProductDetails() {
    $title.innerText = '';
    $message.innerText = '';
    $price.innerHTML = '';
    $price.classList.remove('added-to-cart-modal__price--has-discount');
    $options.innerHTML = '';
}

function buildPriceHTML(product, variantPrice) {
    const isTrade = window.theme.customerType === 'trade';
    const suffix = isTrade ? ' ex. VAT' : '';
    const fmt = (amount) => formatMoney(amount, theme.moneyFormat);

    const originalLinePrice = variantPrice != null
        ? variantPrice * product.quantity
        : product.line_price;
    const isDiscounted = product.final_line_price < originalLinePrice;
    const isOnSale = product.original_price > product.price;

    if (isDiscounted || isOnSale) {
        const displayOriginal = isDiscounted ? originalLinePrice : product.original_price * product.quantity;
        return (
            `<del class="added-to-cart-modal__price--original">${fmt(displayOriginal)}</del>` +
            `<span class="added-to-cart-modal__price--discounted">${fmt(product.final_line_price)}${suffix}</span>`
        );
    }

    return `<span>${fmt(product.final_line_price)}${suffix}</span>`;
}

function buildProductDetails(product, variantPrice) {
    const imageFileTypes = ['.jpg', '.png', '.webp', '.gif'];
    let imageUrl;
    $title.innerText = product.title;
    
    imageFileTypes.forEach(type => {
        if (product.image.includes(type)) {
            imageUrl = product.image.split(type).shift();
            $image.src = `${imageUrl}_150x${type}`;
        }
    });

    if (product.properties.Message && product.properties.Message.length > 0) {
        $message.innerText = `You've added a gift message`;
    }

    const originalLinePrice = variantPrice != null
        ? variantPrice * product.quantity
        : product.line_price;
    const isDiscounted = product.final_line_price < originalLinePrice || product.original_price > product.price;
    $price.innerHTML = buildPriceHTML(product, variantPrice);
    $price.classList.toggle('added-to-cart-modal__price--has-discount', isDiscounted);

    product.options_with_values.forEach(option => {
        const $newOption = document.createElement('p');
        const textNode = document.createTextNode(
            `${option.name}: ${option.value}`
        );
        $newOption.appendChild(textNode);
        $options.appendChild($newOption);
    });

    $quantityCount.innerText = product.quantity;
}

function addEventListeners() {
    window.addEventListener('cart.added', e => {
        const { productData, variantPrice } = e.detail;
        resetPreviousProductDetails();
        buildProductDetails(productData, variantPrice);
        $image.decode().then(() => show());
        setTimeout(() => hide(), 7000);
    });
    $addedToCartModalWrapper.addEventListener('click', () => {
        hide();
    });
}

if ($addedToCartModalWrapper) {
    addEventListeners();
}
